var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Lottie',{staticClass:"logo",class:{ 'logo--visible': _vm.isLoading },attrs:{"width":_vm.width,"height":_vm.height,"options":this.options},on:{"animCreated":_vm.setAnimationController}})}
var staticRenderFns = []

export { render, staticRenderFns }